import { AlertType } from '@lux/inline-alert';
import { TYPE_ERROR, TYPE_SUCCESS } from '@pegasus/ui-flashmessages/dist/constants';

export type FlashmessageType = typeof TYPE_SUCCESS | typeof TYPE_ERROR;

export const convertFlashMessageToAlertType = (
    type: FlashmessageType | 'warning' | 'info',
): (typeof AlertType)[keyof typeof AlertType] => {
    switch (type) {
        case TYPE_ERROR:
        case 'warning': {
            return AlertType.ERROR;
        }
        case 'info': {
            return AlertType.INFO;
        }
        case TYPE_SUCCESS: {
            return AlertType.SUCCESS;
        }
        default: {
            return AlertType.INFO;
        }
    }
};
